<vw-toast-popup
  [isOpen]="isOpen"
  width="100%"
  borderRadius="20px"
  customClass="bg-white"
  (close)="onClose()"
>
  <div class="px-4 py-2">
    <h2 class="text-2xl text-[#062825] font-semibold pb-1">
      {{ 'profile.notification-preferences.title' | translate }}
    </h2>
    <p class="text-sm text-[#9BA6A1] pb-4">
      {{ 'profile.notification-preferences.description' | translate }}
    </p>

    @if (loading) {
    <div class="py-8 text-center text-[#9BA6A1] text-sm">
      {{ 'profile.notification-preferences.loading' | translate }}
    </div>
    } @else {
    <div class="flex flex-col">
      @for (p of preferences; track p.category) {
      <div class="py-3 border-b border-gray-100">
        <div class="flex items-center justify-between">
          <span class="text-base text-primary-dark font-semibold">
            {{
              'profile.notification-preferences.categories.' + p.category
                | translate
            }}
          </span>
          <label class="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              [(ngModel)]="p.isEnabled"
              class="sr-only peer"
            />
            <div
              class="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-primary transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5"
            ></div>
          </label>
        </div>

        <div
          class="flex items-center justify-between mt-3"
          [class.opacity-40]="!p.isEnabled"
        >
          <div class="flex items-center gap-3">
            <span class="text-sm text-primary-dark">
              {{ 'profile.notification-preferences.push-enabled' | translate }}
            </span>
            <label class="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                [(ngModel)]="p.pushEnabled"
                [disabled]="!p.isEnabled"
                class="sr-only peer"
              />
              <div
                class="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-primary transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5"
              ></div>
            </label>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-xs text-[#9BA6A1]">
              {{ 'profile.notification-preferences.min-severity' | translate }}
            </span>
            <select
              [(ngModel)]="p.minPushSeverity"
              [disabled]="!p.isEnabled"
              class="text-sm text-primary-dark bg-white border border-gray-200 rounded-lg px-2 py-1"
            >
              @for (s of severityOptions; track s.value) {
              <option [ngValue]="s.value">{{ s.label | translate }}</option>
              }
            </select>
          </div>
        </div>
      </div>
      }
    </div>

    <div class="mt-6">
      <vw-button
        [label]="'profile.notification-preferences.save' | translate"
        look="primary"
        [loading]="saving"
        (onClick)="save()"
        customClass="w-full"
      ></vw-button>
    </div>
    }
  </div>
</vw-toast-popup>
